"use strict";

exports.__esModule = true;
exports.default = void 0;
var isCordova = function isCordova() {
  return typeof window !== 'undefined' && (typeof window.PhoneGap !== 'undefined' || typeof window.Cordova !== 'undefined' || typeof window.cordova !== 'undefined');
};
var _default = exports.default = isCordova;